export default __webpack_public_path__ + "static/media/phil_with_three_kids.30867b1d.jpg";